import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React from "react";
import { Disableable } from "../Disableable";
import { QuestionHeading } from "./QuestionHeading";
import { RadioGroup as AquiloRadioGroup } from "@truevault/aquilo";

type VendorBooleanQuestionProps = {
  question: React.ReactNode;
  questionKey?: string;
  condensed: boolean;
  disabled?: boolean;
  disabledTooltip?: string;
  helpText: React.ReactNode;
  value: boolean;
  onChange: (value: boolean) => any;
  indented?: boolean;
  nextIndented?: boolean;
  hidden?: boolean;
  useAquiloDesign?: boolean;
};

export const VendorBooleanQuestion: React.FC<VendorBooleanQuestionProps> = ({
  question,
  questionKey,
  condensed,
  disabled,
  disabledTooltip,
  helpText,
  value,
  onChange,
  indented = false,
  nextIndented = false,
  hidden = false,
  useAquiloDesign = false,
}) => {
  if (hidden) {
    return null;
  }
  let val = "";
  if (value === true) {
    val = "yes";
  }
  if (value === false) {
    val = "no";
  }

  if (useAquiloDesign) {
    let radioGroupName =
      questionKey || (typeof question == "string" ? question : "boolean-question");
    return (
      <div className="flex items-center">
        <div>
          <div className="text-neutral-900 text-[14px] font-medium">{question}</div>
          <div className="text-neutral-500 text-[14px] font-normal leading-4">{helpText}</div>
        </div>
        <div>
          <AquiloRadioGroup
            name={radioGroupName}
            selectedValue={val}
            onChange={(newVal) => onChange(newVal === "yes")}
            direction="horizontal"
            options={[
              {
                label: "Yes",
                value: "yes",
                disabled: disabled,
              },
              {
                label: "No",
                value: "no",
                disabled: disabled,
              },
            ]}
          />
        </div>
      </div>
    );
  }

  return (
    <QuestionHeading
      question={question}
      helpText={helpText}
      condensed={condensed}
      indented={indented}
      nextIndented={nextIndented}
      disabled={disabled}
    >
      <div
        style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", minWidth: 256 }}
      >
        <RadioGroup row value={val} onChange={(e) => onChange(e.target.value == "yes")}>
          <Disableable disabled={disabled} disabledTooltip={disabledTooltip}>
            <FormControlLabel
              value="yes"
              label="Yes"
              control={<Radio checked={val == "yes"} />}
              disabled={disabled}
            />
          </Disableable>
          <Disableable disabled={disabled} disabledTooltip={disabledTooltip}>
            <FormControlLabel
              value="no"
              label="No"
              control={<Radio checked={val == "no"} />}
              disabled={disabled}
            />
          </Disableable>
        </RadioGroup>
      </div>
    </QuestionHeading>
  );
};
